import {
  object,
  string,
  array,
  number,
  SchemaOf,
  mixed,
  StringSchema,
} from 'yup';

import { DockerRBACFormValues, UnifiedAccess } from './types';

export function createDockerRBACValidationSchema(
  nameValidation: StringSchema<string>
): SchemaOf<DockerRBACFormValues> {
  return object({
    name: nameValidation,
    environmentGroupIds: array(number().required()),
    accessList: array(
      object({
        Id: number().min(1).required(),
        PartyId: number().min(1).required(),
        Type: mixed<Exclude<UnifiedAccess['Type'], ''>>().required(),
        Name: string().required(),
        Role: object({
          Id: number().min(1).required(),
          Name: string().required(),
        }).required(),
      })
    )
      .required('At least one user or team access is required')
      .min(1, 'At least one user or team access is required'),
  });
}
